// File for logic corresponding to CTA component
import { Component } from 'js-component-framework';

// Styles
import './cta.scss';

/**
 * Component for cta
 */
export default class CTA extends Component {
  return;
}
